import session from '@/shared/session'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
	workoutOverview ({},data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/workout/', { params: data,
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	workoutDetail ({},data) {
		return new Promise((resolve, reject) => {
			session.get(`/api/workouts/workout/${data.id}/`, {
                headers:{
                  "Authorization":"Token "+ localStorage.getItem('token'),
                  "Content-Type": "application/json"
                }
            }
            )
			.then(response => {
				const data = response.data
				console.log(response)
				resolve(data)

			}).catch(errors => {
				resolve(errors)
			})
		})
	},
	workoutCreate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.post('api/workouts/workout/', data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	workoutUpdate ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.put(`/api/workouts/workout/${data.id}/`, data,{
				headers:{
				"Authorization":"Token "+ localStorage.getItem('token'),
				"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	workoutRemove ({commit}, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/workout/partial_update_delete/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				reject(errors.response.data)
			})
		})
	},
	filterworkout ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.get('/api/workouts/workout/get_filtered_workout/', { params: data,
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
    workoutStatusUpdate ({ commit }, data) {
		return new Promise((resolve, reject) => {
			session.patch(`/api/workouts/workout/partial_update_status/${data.id}/`, data, {
				headers:{
					"Authorization":"Token "+ localStorage.getItem('token'),
					"Content-Type": "application/json"
				}
			})
			.then(response => {
				const data = response.data
				resolve(data)

			}).catch(errors => {
				resolve(errors.response.data)
			})
		})
	},
}

// mutations
const mutations = {}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
